import dayjs from "dayjs";

export const addSurveyData = (res: any) => {
    const DataObj = {
        plan_area_id: res[0].plan_area_id,
        branch: res[0].branch,
        create_date: res[0].create_date,
        update_date: res[0].update_date,
        delete_flag: res[0].delete_flag,
        cover_excel_path: res[0].cover_excel_path,
        cover_excel_user: res[0].cover_excel_user,
        cover_pdf_path: res[0].cover_pdf_path,
        cover_pdf_user: res[0].cover_pdf_user,
        doc_pdf_path: addDocPdfPathProperties(JSON.parse(res[0].doc_pdf_path)),
        reference_value_1: res[0].reference_value_1,
        reference_value_2: res[0].reference_value_2,
        reference_value_3: res[0].reference_value_3,
        reference_value_4: res[0].reference_value_4,
        reference_value_5: res[0].reference_value_5,
        approval_mgr_flag: res[0].approval_mgr_flag,
        approval_mgr_user: res[0].approval_mgr_user,
        approval_mgr_department: res[0].approval_mgr_department,
        approval_mgr_date: res[0].approval_mgr_date,
        approval_mgr_stamp: res[0].approval_mgr_stamp,
        approval_gm_flag: res[0].approval_gm_flag,
        approval_gm_user: res[0].approval_gm_user,
        approval_gm_department: res[0].approval_gm_department,
        approval_gm_date: res[0].approval_gm_date,
        approval_gm_stamp: res[0].approval_gm_stamp,
        approval_research_mgr_flag: res[0].approval_research_mgr_flag,
        approval_research_mgr_user: res[0].approval_research_mgr_user,
        approval_research_mgr_department:
            res[0].approval_research_mgr_department,
        approval_research_mgr_date: res[0].approval_research_mgr_date,
        approval_research_mgr_stamp: res[0].approval_research_mgr_stamp,
        approval_research_gm_flag: res[0].approval_research_gm_flag,
        approval_research_gm_user: res[0].approval_research_gm_user,
        approval_research_gm_department: res[0].approval_research_gm_department,
        approval_research_gm_date: res[0].approval_research_gm_date,
        approval_research_gm_stamp: res[0].approval_research_gm_stamp,
        cover_confirm_excel_path: res[0].cover_confirm_excel_path,
        cover_confirm_excel_user: res[0].cover_confirm_excel_user,
        cover_confirm_pdf_path: res[0].cover_confirm_pdf_path,
        cover_confirm_pdf_user: res[0].cover_confirm_pdf_user,
        approval_reference_staff_flag: res[0].approval_reference_staff_flag,
        approval_reference_staff_user: res[0].approval_reference_staff_user,
        approval_reference_staff_department:
            res[0].approval_reference_staff_department,
        approval_reference_staff_date: res[0].approval_reference_staff_date,
        approval_reference_staff_stamp: res[0].approval_reference_staff_stamp,
        approval_reference_research_mgr_flag:
            res[0].approval_reference_research_mgr_flag,
        approval_reference_research_mgr_user:
            res[0].approval_reference_research_mgr_user,
        approval_reference_research_mgr_department:
            res[0].approval_reference_research_mgr_department,
        approval_reference_research_mgr_date:
            res[0].approval_reference_research_mgr_date,
        approval_reference_research_mgr_stamp:
            res[0].approval_reference_research_mgr_stamp,
        approval_reference_research_gm_flag:
            res[0].approval_reference_research_gm_flag,
        approval_reference_research_gm_user:
            res[0].approval_reference_research_gm_user,
        approval_reference_research_gm_department:
            res[0].approval_reference_research_gm_department,
        approval_reference_research_gm_date:
            res[0].approval_reference_research_gm_date,
        approval_reference_research_gm_stamp:
            res[0].approval_reference_research_gm_stamp,
        approval_reference_rm_flag: res[0].approval_reference_rm_flag,
        approval_reference_rm_user: res[0].approval_reference_rm_user,
        approval_reference_rm_department:
            res[0].approval_reference_rm_department,
        approval_reference_rm_date: res[0].approval_reference_rm_date,
        approval_reference_rm_stamp: res[0].approval_reference_rm_stamp,
        merge_file_path: res[0].merge_file_path !== ""
                        ? JSON.parse(res[0].merge_file_path)
                        : [],
        forecast_value_1: res[0].forecast_value_1,
        forecast_value_2: res[0].forecast_value_2,
        forecast_value_3: res[0].forecast_value_3,
    };
    return DataObj;
};

//調査書基本テーブル ファイルアップロード
export const upsertLocationAddSurveyFileParam = (data: any) => {
    const params = {
        mode: "regist",
        endPoint: "/location/AddSurvey/v1/regist",
        query: locationAddSurveyQuery(data),
    };
    return params;
};

//追加調査テーブル ファイルアップロードquery
export const locationAddSurveyQuery = (data: any) => {
    let cover_excel_path = data.objLocationAddSurvey.cover_excel_path;
    let cover_excel_user = data.objLocationAddSurvey.cover_excel_user;
    let cover_pdf_path = data.objLocationAddSurvey.cover_pdf_path;
    let cover_pdf_user = data.objLocationAddSurvey.cover_pdf_user;
    let doc_pdf_path = data.objLocationAddSurvey.doc_pdf_path;
    let cover_confirm_excel_path =
        data.objLocationAddSurvey.cover_confirm_excel_path;
    let cover_confirm_excel_user =
        data.objLocationAddSurvey.cover_confirm_excel_user;
    let cover_confirm_pdf_path =
        data.objLocationAddSurvey.cover_confirm_pdf_path;
    let cover_confirm_pdf_user =
        data.objLocationAddSurvey.cover_confirm_pdf_user;
    let merge_file_path =
        data.objLocationAddSurvey.merge_file_path;
    // 参考値
    let approval_reference_staff_flag =
        data.objLocationAddSurvey.approval_reference_staff_flag;
    let approval_reference_staff_user =
        data.objLocationAddSurvey.approval_reference_staff_user;
    let approval_reference_staff_department =
        data.objLocationAddSurvey.approval_reference_staff_department;
    let approval_reference_staff_date =
        data.objLocationAddSurvey.approval_reference_staff_date;
    let approval_reference_staff_stamp =
        data.objLocationAddSurvey.approval_reference_staff_stamp;
    let approval_reference_research_mgr_flag =
        data.objLocationAddSurvey.approval_reference_research_mgr_flag;
    let approval_reference_research_mgr_user =
        data.objLocationAddSurvey.approval_reference_research_mgr_user;
    let approval_reference_research_mgr_department =
        data.objLocationAddSurvey.approval_reference_research_mgr_department;
    let approval_reference_research_mgr_date =
        data.objLocationAddSurvey.approval_reference_research_mgr_date;
    let approval_reference_research_mgr_stamp =
        data.objLocationAddSurvey.approval_reference_research_mgr_stamp;
    let approval_reference_research_gm_flag =
        data.objLocationAddSurvey.approval_reference_research_gm_flag;
    let approval_reference_research_gm_user =
        data.objLocationAddSurvey.approval_reference_research_gm_user;
    let approval_reference_research_gm_department =
        data.objLocationAddSurvey.approval_reference_research_gm_department;
    let approval_reference_research_gm_date =
        data.objLocationAddSurvey.approval_reference_research_gm_date;
    let approval_reference_research_gm_stamp =
        data.objLocationAddSurvey.approval_reference_research_gm_stamp;
    let approval_reference_rm_flag =
        data.objLocationAddSurvey.approval_reference_rm_flag;
    let approval_reference_rm_user =
        data.objLocationAddSurvey.approval_reference_rm_user;
    let approval_reference_rm_department =
        data.objLocationAddSurvey.approval_reference_rm_department;
    let approval_reference_rm_date =
        data.objLocationAddSurvey.approval_reference_rm_date;
    let approval_reference_rm_stamp =
        data.objLocationAddSurvey.approval_reference_rm_stamp;
    // 確定値
    let approval_mgr_flag = data.objLocationAddSurvey.approval_mgr_flag;
    let approval_mgr_user = data.objLocationAddSurvey.approval_mgr_user;
    let approval_mgr_department =
        data.objLocationAddSurvey.approval_mgr_department;
    let approval_mgr_date = data.objLocationAddSurvey.approval_mgr_date;
    let approval_mgr_stamp = data.objLocationAddSurvey.approval_mgr_stamp;
    let approval_gm_flag = data.objLocationAddSurvey.approval_gm_flag;
    let approval_gm_user = data.objLocationAddSurvey.approval_gm_user;
    let approval_gm_department =
        data.objLocationAddSurvey.approval_gm_department;
    let approval_gm_date = data.objLocationAddSurvey.approval_gm_date;
    let approval_gm_stamp = data.objLocationAddSurvey.approval_gm_stamp;
    let approval_research_mgr_flag =
        data.objLocationAddSurvey.approval_research_mgr_flag;
    let approval_research_mgr_user =
        data.objLocationAddSurvey.approval_research_mgr_user;
    let approval_research_mgr_department =
        data.objLocationAddSurvey.approval_research_mgr_department;
    let approval_research_mgr_date =
        data.objLocationAddSurvey.approval_research_mgr_date;
    let approval_research_mgr_stamp =
        data.objLocationAddSurvey.approval_research_mgr_stamp;
    let approval_research_gm_flag =
        data.objLocationAddSurvey.approval_research_gm_flag;
    let approval_research_gm_user =
        data.objLocationAddSurvey.approval_research_gm_user;
    let approval_research_gm_department =
        data.objLocationAddSurvey.approval_research_gm_department;
    let approval_research_gm_date =
        data.objLocationAddSurvey.approval_research_gm_date;
    let approval_research_gm_stamp =
        data.objLocationAddSurvey.approval_research_gm_stamp;
    let isUpload = true;

    switch (data.column) {
        case "cover_excel_path":
            cover_excel_path = data.uploadFile;
            cover_excel_user = data.user_id;
            cover_pdf_path = data.pdfFileName;
            cover_pdf_user = data.user_id;
            break;
        case "cover_excel_delete":
            cover_excel_path = "";
            cover_excel_user = "";
            cover_pdf_path = "";
            cover_pdf_user = "";
            isUpload = false;
            break;
        case "cover_confirm_excel_path":
            cover_confirm_excel_path = data.uploadFile;
            cover_confirm_excel_user = data.user_id;
            cover_confirm_pdf_path = data.pdfFileName;
            cover_confirm_pdf_user = data.user_id;
            break;
        case "cover_confirm_excel_delete":
            cover_confirm_excel_path = "";
            cover_confirm_excel_user = "";
            cover_confirm_pdf_path = "";
            cover_confirm_pdf_user = "";
            break;
        case "doc_pdf_path":
            doc_pdf_path = [].concat(
                data.objLocationAddSurvey.doc_pdf_path,
                data.uploadFile
            );
            break;
        case "delete_doc_pdf_path":
            data.column = "doc_pdf_path";
            doc_pdf_path = data.uploadFile;
            break;
        case "cover_reference":
            approval_reference_staff_flag = "";
            approval_reference_staff_user = "";
            approval_reference_staff_department = "";
            approval_reference_staff_date = "";
            approval_reference_staff_stamp = "";
            approval_reference_research_mgr_flag = "";
            approval_reference_research_mgr_user = "";
            approval_reference_research_mgr_department = "";
            approval_reference_research_mgr_date = "";
            approval_reference_research_mgr_stamp = "";
            approval_reference_research_gm_flag = "";
            approval_reference_research_gm_user = "";
            approval_reference_research_gm_department = "";
            approval_reference_research_gm_date = "";
            approval_reference_research_gm_stamp = "";
            approval_reference_rm_flag = "";
            approval_reference_rm_user = "";
            approval_reference_rm_department = "";
            approval_reference_rm_date = "";
            approval_reference_rm_stamp = "";
            break;
        case "cover_confirmed":
            approval_mgr_flag = "";
            approval_mgr_user = "";
            approval_mgr_department = "";
            approval_mgr_date = "";
            approval_mgr_stamp = "";
            approval_gm_flag = "";
            approval_gm_user = "";
            approval_gm_department = "";
            approval_gm_date = "";
            approval_gm_stamp = "";
            approval_research_mgr_flag = "";
            approval_research_mgr_user = "";
            approval_research_mgr_department = "";
            approval_research_mgr_date = "";
            approval_research_mgr_stamp = "";
            approval_research_gm_flag = "";
            approval_research_gm_user = "";
            approval_research_gm_department = "";
            approval_research_gm_date = "";
            approval_research_gm_stamp = "";
            break;
        case "comment_addsurvey":
            approval_reference_staff_flag = "1";
            approval_reference_staff_user = data.user_id;
            approval_reference_staff_department = data.department;
            approval_reference_staff_date = dayjs().format(
                "YYYY-MM-DD HH:mm:ss"
            );
            approval_reference_staff_stamp = data.inei_file_path;
            break;
    }

    const logStatus = setLogStatus(data.column, isUpload, data.fileName);

    return {
        plan_area_id: data.plan_area_id,
        branch: data.branch,
        cover_excel_path: cover_excel_path,
        cover_excel_user: cover_excel_user,
        cover_pdf_path: cover_pdf_path,
        cover_pdf_user: cover_pdf_user,
        doc_pdf_path: JSON.stringify(addDocPdfPathProperties(doc_pdf_path)),
        reference_value_1: data.objLocationAddSurvey.reference_value_1,
        reference_value_2: data.objLocationAddSurvey.reference_value_2,
        reference_value_3: data.objLocationAddSurvey.reference_value_3,
        reference_value_4: data.objLocationAddSurvey.reference_value_4,
        reference_value_5: data.objLocationAddSurvey.reference_value_5,
        approval_mgr_flag: approval_mgr_flag,
        approval_mgr_user: approval_mgr_user,
        approval_mgr_department: approval_mgr_department,
        approval_mgr_date: approval_mgr_date,
        approval_mgr_stamp: approval_mgr_stamp,
        approval_gm_flag: approval_gm_flag,
        approval_gm_user: approval_gm_user,
        approval_gm_department: approval_gm_department,
        approval_gm_date: approval_gm_date,
        approval_gm_stamp: approval_gm_stamp,
        approval_research_mgr_flag: approval_research_mgr_flag,
        approval_research_mgr_user: approval_research_mgr_user,
        approval_research_mgr_department: approval_research_mgr_department,
        approval_research_mgr_date: approval_research_mgr_date,
        approval_research_mgr_stamp: approval_research_mgr_stamp,
        approval_research_gm_flag: approval_research_gm_flag,
        approval_research_gm_user: approval_research_gm_user,
        approval_research_gm_department: approval_research_gm_department,
        approval_research_gm_date: approval_research_gm_date,
        approval_research_gm_stamp: approval_research_gm_stamp,
        cover_confirm_excel_path: cover_confirm_excel_path,
        cover_confirm_excel_user: cover_confirm_excel_user,
        cover_confirm_pdf_path: cover_confirm_pdf_path,
        cover_confirm_pdf_user: cover_confirm_pdf_user,
        approval_reference_staff_flag: approval_reference_staff_flag,
        approval_reference_staff_user: approval_reference_staff_user,
        approval_reference_staff_department:
            approval_reference_staff_department,
        approval_reference_staff_date: approval_reference_staff_date,
        approval_reference_staff_stamp: approval_reference_staff_stamp,
        approval_reference_research_mgr_flag:
            approval_reference_research_mgr_flag,
        approval_reference_research_mgr_user:
            approval_reference_research_mgr_user,
        approval_reference_research_mgr_department:
            approval_reference_research_mgr_department,
        approval_reference_research_mgr_date:
            approval_reference_research_mgr_date,
        approval_reference_research_mgr_stamp:
            approval_reference_research_mgr_stamp,
        approval_reference_research_gm_flag:
            approval_reference_research_gm_flag,
        approval_reference_research_gm_user:
            approval_reference_research_gm_user,
        approval_reference_research_gm_department:
            approval_reference_research_gm_department,
        approval_reference_research_gm_date:
            approval_reference_research_gm_date,
        approval_reference_research_gm_stamp:
            approval_reference_research_gm_stamp,
        approval_reference_rm_flag: approval_reference_rm_flag,
        approval_reference_rm_user: approval_reference_rm_user,
        approval_reference_rm_department: approval_reference_rm_department,
        approval_reference_rm_date: approval_reference_rm_date,
        approval_reference_rm_stamp: approval_reference_rm_stamp,
        merge_file_path: JSON.stringify(merge_file_path),
        column: data.column,
        
        // ログ用
        log_type: logStatus.log_type,
        target_table: logStatus.target_table,
        target_column: logStatus.target_column,
        target_before_value: logStatus.target_before_value,
        target_after_value: logStatus.target_after_value,
    };
};

export const upsertLocationAddSurvey = (
    objLocationAddSurvey: any,
    plan_area_id: any,
    branch: any
) => {
    const params = {
        mode: "regist",
        endPoint: "/location/AddSurvey/v1/regist",
        query: {
            plan_area_id: plan_area_id,
            branch: branch,
            cover_excel_path: objLocationAddSurvey.cover_excel_path,
            cover_excel_user: objLocationAddSurvey.cover_excel_user,
            cover_pdf_path: objLocationAddSurvey.cover_pdf_path,
            cover_pdf_user: objLocationAddSurvey.cover_pdf_user,
            doc_pdf_path: JSON.stringify(addDocPdfPathProperties(objLocationAddSurvey.doc_pdf_path)),
            reference_value_1: objLocationAddSurvey.reference_value_1,
            reference_value_2: objLocationAddSurvey.reference_value_2,
            reference_value_3: objLocationAddSurvey.reference_value_3,
            reference_value_4: objLocationAddSurvey.reference_value_4,
            reference_value_5: objLocationAddSurvey.reference_value_5,
            approval_mgr_flag: objLocationAddSurvey.approval_mgr_flag,
            approval_mgr_user: objLocationAddSurvey.approval_mgr_user,
            approval_mgr_department:
                objLocationAddSurvey.approval_mgr_department,
            approval_mgr_date: objLocationAddSurvey.approval_mgr_date,
            approval_mgr_stamp: objLocationAddSurvey.approval_mgr_stamp,
            approval_gm_flag: objLocationAddSurvey.approval_gm_flag,
            approval_gm_user: objLocationAddSurvey.approval_gm_user,
            approval_gm_department: objLocationAddSurvey.approval_gm_department,
            approval_gm_date: objLocationAddSurvey.approval_gm_date,
            approval_gm_stamp: objLocationAddSurvey.approval_gm_stamp,
            approval_research_mgr_flag:
                objLocationAddSurvey.approval_research_mgr_flag,
            approval_research_mgr_user:
                objLocationAddSurvey.approval_research_mgr_user,
            approval_research_mgr_department:
                objLocationAddSurvey.approval_research_mgr_department,
            approval_research_mgr_date:
                objLocationAddSurvey.approval_research_mgr_date,
            approval_research_mgr_stamp:
                objLocationAddSurvey.approval_research_mgr_stamp,
            approval_research_gm_flag:
                objLocationAddSurvey.approval_research_gm_flag,
            approval_research_gm_user:
                objLocationAddSurvey.approval_research_gm_user,
            approval_research_gm_department:
                objLocationAddSurvey.approval_research_gm_department,
            approval_research_gm_date:
                objLocationAddSurvey.approval_research_gm_date,
            approval_research_gm_stamp:
                objLocationAddSurvey.approval_research_gm_stamp,
            cover_confirm_excel_path: objLocationAddSurvey.cover_confirm_excel_path,
            cover_confirm_excel_user: objLocationAddSurvey.cover_confirm_excel_user,
            cover_confirm_pdf_path: objLocationAddSurvey.cover_confirm_pdf_path,
            cover_confirm_pdf_user: objLocationAddSurvey.cover_confirm_pdf_user,
            approval_reference_staff_flag: objLocationAddSurvey.approval_reference_staff_flag,
            approval_reference_staff_user: objLocationAddSurvey.approval_reference_staff_user,
            approval_reference_staff_department:
                objLocationAddSurvey.approval_reference_staff_department,
            approval_reference_staff_date: objLocationAddSurvey.approval_reference_staff_date,
            approval_reference_staff_stamp: objLocationAddSurvey.approval_reference_staff_stamp,
            approval_reference_research_mgr_flag:
                objLocationAddSurvey.approval_reference_research_mgr_flag,
            approval_reference_research_mgr_user:
                objLocationAddSurvey.approval_reference_research_mgr_user,
            approval_reference_research_mgr_department:
                objLocationAddSurvey.approval_reference_research_mgr_department,
            approval_reference_research_mgr_date:
                objLocationAddSurvey.approval_reference_research_mgr_date,
            approval_reference_research_mgr_stamp:
                objLocationAddSurvey.approval_reference_research_mgr_stamp,
            approval_reference_research_gm_flag:
                objLocationAddSurvey.approval_reference_research_gm_flag,
            approval_reference_research_gm_user:
                objLocationAddSurvey.approval_reference_research_gm_user,
            approval_reference_research_gm_department:
                objLocationAddSurvey.approval_reference_research_gm_department,
            approval_reference_research_gm_date:
                objLocationAddSurvey.approval_reference_research_gm_date,
            approval_reference_research_gm_stamp:
                objLocationAddSurvey.approval_reference_research_gm_stamp,
            approval_reference_rm_flag: objLocationAddSurvey.approval_reference_rm_flag,
            approval_reference_rm_user: objLocationAddSurvey.approval_reference_rm_user,
            approval_reference_rm_department: objLocationAddSurvey.approval_reference_rm_department,
            approval_reference_rm_date: objLocationAddSurvey.approval_reference_rm_date,
            approval_reference_rm_stamp: objLocationAddSurvey.approval_reference_rm_stamp,
            merge_file_path: JSON.stringify(objLocationAddSurvey.merge_file_path),

            // ログ用
            log_type: "0",
            column: "merge_file_upload"
        },
    };

    return params;
};

// ログステータス
const setLogStatus = (column: string, isUpload: boolean, fileName: string) => {
    let log_type = "";
    let target_table = "";
    let target_column = "";
    let target_before_value = "";
    let target_after_value = "";
    let target_file_name = fileName;

    switch (column) {
        case "cover_excel_path":
            log_type = "7";
            target_table = "追加調査";
            target_file_name = "表紙";
            break;
        case "doc_pdf_path":
            log_type = "7";
            target_table = "追加調査";
            break;
    }
    target_column = isUpload ? "ファイルアップロード" : "ファイル削除";
    target_before_value = isUpload ? "" : target_file_name;
    target_after_value = isUpload ? target_file_name : "";

    return {
        log_type: log_type,
        target_table: target_table,
        target_column: target_column,
        target_before_value: target_before_value,
        target_after_value: target_after_value,
    };
};

//アップロード JSON形式データ加工
export const uploadFileJsonPathFunc = (res: any, userId: string) => {
    let filePath = "";

    if (res.fullPath.includes("/excel")) {
        filePath = "/excel/" + res.name;
    } else if (res.fullPath.includes("/pdf")) {
        filePath = "/pdf/" + res.name;
    } else if (res.fullPath.includes("/rr_document")) {
        filePath = "/rr_document/" + res.name;
    } else if (res.fullPath.includes("/drawing")) {
        filePath = "/drawing/" + res.name;
    }

    return {
        file_name: res.name,
        file_path: filePath,
        upload_date: dayjs(res.timeCreated).format("YYYY/MM/DD HH:mm:ss"),
        upload_staff_number: userId,
    };
};

export const settingTaskId = (param: any, data: any) => {
    let taskId = "";
    const additionalResearch = data.objApprovalSurvey.additionalResearch;
    const confirmAdditionalResearch =
        data.objApprovalSurvey.confirmAdditionalResearch;

    let addSurvey = JSON.parse(JSON.stringify(data.objLocationAddSurvey));
    addSurvey.doc_pdf_path = JSON.stringify(addDocPdfPathProperties(addSurvey.doc_pdf_path));
    addSurvey.merge_file_path = JSON.stringify(addSurvey.merge_file_path);
    let department = "";
    let hasMail = false;
    const staffMasterObj = localStorage.getItem("staffMaster");
    if (staffMasterObj !== null) {
        const jsonStaffMasterObj = JSON.parse(staffMasterObj);
        jsonStaffMasterObj.forEach((row: any) => {
            if (row.department_code_oa === data.userData.department_code_OA) {
                department = row.department_name_oa;
            }
        });
    }
    const stamp_date = dayjs().format("YYYY-MM-DD HH:mm:ss");
    switch (data.task_id) {
        case "E001":
            if (additionalResearch === "1") {
                taskId = "E004";
                addSurvey.approval_reference_rm_flag = "1";
                addSurvey.approval_reference_rm_user =
                    data.userData.staff_number;
                addSurvey.approval_reference_rm_department = department;
                addSurvey.approval_reference_rm_date = stamp_date;
                addSurvey.approval_reference_rm_stamp = param.inei_file_path;
            } else {
                taskId = "E020";
                addSurvey.approval_reference_rm_flag = "";
                addSurvey.approval_reference_rm_user = "";
                addSurvey.approval_reference_rm_department = "";
                addSurvey.approval_reference_rm_date = "";
                addSurvey.approval_reference_rm_stamp = "";
            }
            break;
        case "E010":
        case "E012":
            if (
                additionalResearch === "1" &&
                confirmAdditionalResearch === "1"
            ) {
                taskId = "E014";
                addSurvey.approval_reference_research_mgr_flag = "1";
                addSurvey.approval_reference_research_mgr_user =
                    data.userData.staff_number;
                addSurvey.approval_reference_research_mgr_department =
                    department;
                addSurvey.approval_reference_research_mgr_date = stamp_date;
                addSurvey.approval_reference_research_mgr_stamp =
                    param.inei_file_path;
                // メール
                hasMail = true;
            } else if (additionalResearch === "1") {
                taskId = "E016";
                addSurvey.approval_reference_research_mgr_flag = "1";
                addSurvey.approval_reference_research_mgr_user =
                    data.userData.staff_number;
                addSurvey.approval_reference_research_mgr_department =
                    department;
                addSurvey.approval_reference_research_mgr_date = stamp_date;
                addSurvey.approval_reference_research_mgr_stamp =
                    param.inei_file_path;
            } else {
                taskId = "E005";
                addSurvey.approval_reference_research_mgr_flag = "";
                addSurvey.approval_reference_research_mgr_user = "";
                addSurvey.approval_reference_research_mgr_department = "";
                addSurvey.approval_reference_research_mgr_date = "";
                addSurvey.approval_reference_research_mgr_stamp = "";
            }
            break;
        case "E014":
            if (additionalResearch === "1") {
                taskId = "E016";
                addSurvey.approval_reference_research_gm_flag = "1";
                addSurvey.approval_reference_research_gm_user =
                    data.userData.staff_number;
                addSurvey.approval_reference_research_gm_department =
                    department;
                addSurvey.approval_reference_research_gm_date = stamp_date;
                addSurvey.approval_reference_research_gm_stamp =
                    param.inei_file_path;
            } else {
                taskId = "E012";
                addSurvey.approval_reference_research_gm_flag = "";
                addSurvey.approval_reference_research_gm_user = "";
                addSurvey.approval_reference_research_gm_department = "";
                addSurvey.approval_reference_research_gm_date = "";
                addSurvey.approval_reference_research_gm_stamp = "";
                hasMail = true;
            }
            break;
        case "E002":
            if (additionalResearch === "1") {
                taskId = "E003";
                addSurvey.approval_mgr_flag = "1";
                addSurvey.approval_mgr_user = data.userData.staff_number;
                addSurvey.approval_mgr_department = department;
                addSurvey.approval_mgr_date = stamp_date;
                addSurvey.approval_mgr_stamp = param.inei_file_path;
                hasMail = true;
            } else {
                taskId = "E020";
                addSurvey.approval_mgr_flag = "";
                addSurvey.approval_mgr_user = "";
                addSurvey.approval_mgr_department = "";
                addSurvey.approval_mgr_date = "";
                addSurvey.approval_mgr_stamp = "";
            }
            break;
        case "E003":
            if (additionalResearch === "1") {
                taskId = "E008";
                addSurvey.approval_gm_flag = "1";
                addSurvey.approval_gm_user = data.userData.staff_number;
                addSurvey.approval_gm_department = department;
                addSurvey.approval_gm_date = stamp_date;
                addSurvey.approval_gm_stamp = param.inei_file_path;
            } else {
                taskId = "E020";
                addSurvey.approval_gm_flag = "";
                addSurvey.approval_gm_user = "";
                addSurvey.approval_gm_department = "";
                addSurvey.approval_gm_date = "";
                addSurvey.approval_gm_stamp = "";
            }
            break;
        case "E011":
        case "E013":
            if (additionalResearch === "1") {
                taskId = "E015";
                addSurvey.approval_research_mgr_flag = "1";
                addSurvey.approval_research_mgr_user =
                    data.userData.staff_number;
                addSurvey.approval_research_mgr_department = department;
                addSurvey.approval_research_mgr_date = stamp_date;
                addSurvey.approval_research_mgr_stamp = param.inei_file_path;
                hasMail = true;
            } else {
                taskId = "E006";
                addSurvey.approval_research_mgr_flag = "";
                addSurvey.approval_research_mgr_user = "";
                addSurvey.approval_research_mgr_department = "";
                addSurvey.approval_research_mgr_date = "";
                addSurvey.approval_research_mgr_stamp = "";
            }
            break;
        case "E015":
            if (additionalResearch === "1") {
                taskId = "E018";
                addSurvey.approval_research_gm_flag = "1";
                addSurvey.approval_research_gm_user =
                    data.userData.staff_number;
                addSurvey.approval_research_gm_department = department;
                addSurvey.approval_research_gm_date = stamp_date;
                addSurvey.approval_research_gm_stamp = param.inei_file_path;
            } else {
                taskId = "E013";
                addSurvey.approval_research_gm_flag = "";
                addSurvey.approval_research_gm_user = "";
                addSurvey.approval_research_gm_department = "";
                addSurvey.approval_research_gm_date = "";
                addSurvey.approval_research_gm_stamp = "";
            }
            break;
    }

    return {
        taskId: taskId,
        addSurvey: addSurvey,
        hasMail: hasMail,
    };
};

//日付表示用関数
export const showUploadDate = (param: any) => {
    let date = ""
    if (param) {
        date = dayjs(param).format('YYYY/MM/DD HH:mm:ss')
    }
    return date
};

//isExcludedとmerge_orderプロパティを追加する関数
const addDocPdfPathProperties = (parsedData: any[]): any[] => {
    return parsedData.map((item: any) => {
        return {
            file_name: item.file_name,
            file_path: item.file_path,
            upload_date: item.upload_date,
            upload_staff_number: item.upload_staff_number,
            isExcluded: item.hasOwnProperty("isExcluded") ? item.isExcluded : false,
            merge_order: item.hasOwnProperty("merge_order") ? item.merge_order : "",
        };
    });
};
